<template>
  <div>
    <expandable-group
      v-for="group in accessoriesGrouped"
      :key="group.name"
      :title="group.name"
      class="accessory-group"
      :arialabel-expand="$t('expandAccessoryCategory', [group.name])"
      :arialabel-collapse="$t('collapseAccessoryCategory', [group.name])"
    >
      <div v-for="(products, name) in group.types" :key="name + '-title'">
        <product-accessories-category class="mb-2" :name="name" :products="products" />
      </div>
    </expandable-group>
  </div>
</template>

<script setup lang="ts">
import ExpandableGroup from '@/components/ExpandableGroup.vue'
import ProductAccessoriesCategory from '@/modules/product/components/ProductAccessoriesCategory.vue'
import { AccessoryGroup, MediumProduct } from '@/types/index'
import { computed, PropType } from 'vue'

const props = defineProps({
  accessories: {
    type: Array as PropType<AccessoryGroup[]>,
    required: true
  }
})

const mapAccessoryGroup = (group: AccessoryGroup) => {
  const types: Record<string, MediumProduct[]> = {}

  for (const product of group.products) {
    const typeName = product.productType.name
    if (!types[typeName]) {
      types[typeName] = []
    }
    types[typeName].push(product)
  }

  return { name: group.groupName, types }
}

const accessoriesGrouped = computed(() => props.accessories.map(mapAccessoryGroup))
</script>
